import styled from "styled-components";

export const Container = styled.div`
  padding-left: 14rem;
  padding-right: 14rem;

  .clickable-element {
    cursor: pointer;
  }
`;

export const SubContainer = styled.div`
  width: 90rem;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
  .item-a {
    justify-self: start;
    margin-top: 3.2rem;
  }
  .item-b {
    justify-self: end;
    margin-top: 3.2rem;
  }

  .auxiliar {
    display: flex;
    justify-content: space-between;
    width: 44rem;
  }
  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
    width: 44rem;
  }

  .react-date-picker__wrapper {
    border: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3.2rem;
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
  font-size: 1.4rem;
  font-weight: 600;
`;

export const SubtitleFile = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: -1.4rem;
  margin-top: 3.2rem;
`;

interface IMainButton {
  isLoading?: any;
  isDisabled?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    background-color: ${
      props.isDisabled
        ? props.theme.colors.accentGreen + props.theme.transparencies.p20
        : props.theme.colors.accentGreen
    };
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  width: 27.2rem;

  img {
    margin-right: 1rem;
  }

  .spinner {
    height: 5rem;
    width: 5rem;
  }
`;

interface ICancelButton {
  isLoading?: any;
}
export const CancelButton = styled.button<ICancelButton>`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    cursor: ${props.isLoading ? "default" : "pointer"};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-right: 2rem;
  width: 24.1rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: default;
  }
`;

export const TextContainer = styled.div`
  margin-top: 3.2rem;
`;

interface ITextArea {
  hasError?: any;
  type?: any;
}
export const TextArea = styled.textarea<ITextArea>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };  
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 0.8rem;
  box-shadow: 0px 5px 30px rgb(231 231 234 / 62%);
  font-size: 1.4rem;
  font-weight: 500;
  height: 9.2rem;
  padding: 2rem;
  resize: none;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  h2 {
    font-size: 1.4rem;
    font-weight: 600;
  }
`;

export const CheckBox = styled.div`
  align-items: center;
  display: flex;
  label {
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;
    margin-left: 6rem;
    input {
      margin: 0 1.3rem 0 0;
    }
  }
`;

export const InfoContainer = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
  `}
  border-radius: 0.8rem;
  padding: 1.4rem;
  width: auto;
  p {
    font-size: 1.4rem;
    line-height: 2.4rem;
    margin: 0 0 0.5rem 0;
    padding: 0;
    span {
      font-weight: bold;
      ${(props) => `
        color: ${props.theme.colors.blackBlue};
      `}
    }
  }
`;

export const GrayText = styled.p`
  ${(props) => `
    color: ${props.theme.colors.gray};
  `}
  font-size: 1.2rem;
  font-weight: 500;
`;
